import Model from "../../../Model.js";

/**
 * Abstract class representing the type of period the value of a token is
 * filtered on.
 *
 * When building a FormulaNode out of a token period filter, an expression is
 * wrapped with an instance of a subclass of `PeriodValueFormulaNode`.
 */
export default class AbstractTokenPeriodFilter extends Model {
	getLabel() {
		return this.constructor.getLabel();
	}

	asFormulaNode(...args) {
		const constructor = this._formulaNodeConstructor();
		return new constructor(...args);
	}

	isNull() {
		return false;
	}

	_formulaNodeConstructor() {
		this._subclassResponsibility();
	}

	static instance() {
		this._instance ||= new this();

		return this._instance;
	}

	static getLabel() {
		return "";
	}
}
